/**
 * Copyright © Veeam Software Group GmbH.
 */

import { CloudGatewaySelectionTypeRepresentation } from '@veeam-vspc/models/web-controllers';

export type CloudGatewaySelectionType = CloudGatewaySelectionTypeRepresentation;
export const CloudGatewaySelectionType = CloudGatewaySelectionTypeRepresentation;
